module.exports = __webpack_public_path__ + "static/img/login01.a83b7ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login01.png
// module id = 1047
// module chunks = 1